import { IAudioDevice } from "@formant/core/model/IAudioDevice";
import { IDevice } from "@formant/core/model/IDevice";

export function audioDevicesForDevices(
    devices: IDevice[] | undefined,
): IAudioDevice[] {
    return (
        (devices &&
            devices
                .reduce<IAudioDevice[]>(
                    (acc, _) => [
                        ...acc,
                        ...(_.state?.hwInfo?.audioCaptureDevices || []),
                    ],
                    [],
                )
                .sort((a, b) => a.name.localeCompare(b.name))
                .filter(
                    (_, index, array) =>
                        array.findIndex(e => e.name === _.name) === index,
                )) ||
        []
    );
}
